// extracted by mini-css-extract-plugin
export default {"heading":"kt-z","corrected":"lt-z","redirectVerbiageContainer":"mt-z","redirectVerbiageText":"nt-z"};